export const itemdesc = {
    Bag: {
        title: "Zip Tote Basket",
        description: `The Zip Tote Basket  is the perfect midpoint between shopping
          tote and comfy backpack. With convertible  straps, you can hand   carry, should sling, 
             or backpack this convenient and spacious bag. The zip top and durable canvas construction keeps your goods protected for all-day use.`,
        images: [
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-03-product-01.jpg",
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-03-product-02.jpg",
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-03-product-03.jpg",
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-03-product-04.jpg"
        ],
        dropdowns: [
            {title: "Care", text: "This is the text for care dynamically imported"},
            {title: "Shipping", text: "We offer free Shipping"},
            {title: "Return", text: "Your satisfactory is our guarantee"}
        ]
    },
    Hoodie :{
        title: "Codecademy Hoodie",
        description: "The codecademy Hoodie",
        images: [
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/hoodie.jpg",
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/java-tee.jpg",
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/java-tee.jpg",
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/java-tee.jpg"
        ],
        dropdowns: [
            {title: "Care", text: "This is the text for care dynamically imported"},
            {title: "Shipping", text: "We offer free Shipping"},
            {title: "Return", text: "Your satisfactory is our guarantee"}
        ]
    },
  //Add new items below this line
    Hat :{
        title: "Codecademy Hoodie",
        description: "The codecademy Hoodie",
        images: [
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/hoodie.jpg",
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/java-tee.jpg",
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/java-tee.jpg",
            "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/java-tee.jpg"
        ],
        dropdowns: [
            {title: "Care", text: "This is the text for care dynamically imported"},
            {title: "Shipping", text: "We offer free Shipping"},
            {title: "Return", text: "Your satisfactory is our guarantee"}
        ]
    }
  // Add new items above this line
}